import {initializeApp} from "firebase/app";
import {getAnalytics} from "firebase/analytics";
import {getMessaging} from "firebase/messaging";
import {getAuth} from "firebase/auth";
import config from "./config";

// Единая точка инициализации Firebase (analytics, messaging, auth).
// Конфиг и authDomain берутся из configs.<env>.js: authDomain должен указывать на наш домен,
// на котором nginx проксирует /__/auth в <project>.firebaseapp.com (см. Dockerfile).
export const app = initializeApp(config.FIREBASE);
export const analytics = getAnalytics(app);
export const messaging = 'Notification' in window ? getMessaging(app) : null;
export const auth = getAuth(app);

const storedLanguage = window.localStorage.getItem('language');
if (storedLanguage) {
    auth.languageCode = storedLanguage.toLowerCase();
} else {
    auth.useDeviceLanguage();
}
